<template lang="pug">
  v-select(
    :value="value"
    :items="items"
    :loading="isFetching"
    :error-messages="errorMessages"
    :label="label"
    :autofocus="autofocus"
    no-data-text="Cargando Bancos..."
    name="banco"
    @input="onInput"
  )
</template>

<script>
  import BankSelect from './bank-select';

  export default {
    name: 'simple-bank-select',

    extends: BankSelect,
  };
</script>